function createIOwnThisSetting({ userId, metadataId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/iownthis`;
  return apiClient.post(route, { userId, metadataId });
}

function removeIOwnThisSetting({ userId, ownerSettingId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/iownthis/${ownerSettingId}`;
  return apiClient.delete(route, { userId });
}

export default {
  createIOwnThisSetting,
  removeIOwnThisSetting
};



// WEBPACK FOOTER //
// ./app/api/IOwnThisApi.js